import { useQuery } from '@tanstack/react-query'

import api from 'services/api'

export interface CharLimitResponse {
  [column: string]: number | null
}

interface UseCharLimitResult {
  data: CharLimitResponse
  isLoading: boolean
  error: unknown
}

const WEEKEND_IN_MS = 1000 * 60 * 60 * 24 * 7

const fetchCharLimits = async (
  tableName: string,
  columns?: string[]
): Promise<CharLimitResponse> => {
  const response = await api.post('miscellaneous/queries/max_length', {
    table_name: tableName,
    columns: columns && columns.length > 0 ? columns : undefined,
  })
  return response.data?.data || {}
}

export const useCharLimit = (
  tableName: string,
  columns?: string[]
): UseCharLimitResult =>
  useQuery({
    queryKey: ['char-limit', tableName, columns?.sort().join(',') || 'all'],
    queryFn: () => fetchCharLimits(tableName, columns),
    staleTime: WEEKEND_IN_MS,
    cacheTime: WEEKEND_IN_MS,
    enabled: !!tableName,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    keepPreviousData: false,
    retry: false,
  })
